import axios from 'services/network/axios';

//  *** AreaCodes
export const GetAreaCodes = () => axios.get('Locale/GetAreaCodes');

//  *** Locales
export const GetLocales = () => axios.get('Locale/GetLocales');


